import React from 'react';
import {
  buildAnnualProgressLearningCrossSuffix,
  type AnnualCrossTopicDetailRow,
} from '../../utils/annualProgressCrossTopicExtract';
import ProgramExportTrackTimetableStack from './ProgramExportTrackTimetableStack';

export type LearningContentDetailTableProps = {
  rows: AnnualCrossTopicDetailRow[];
  /** 기본값 `순서` */
  seqColumnLabel?: string;
};

const renderTemplateLabel = (row: AnnualCrossTopicDetailRow) => {
  const hasStack =
    row.templateTrackLabel !== undefined || row.templateTimetableLabel !== undefined;
  if (hasStack) {
    return (
      <ProgramExportTrackTimetableStack
        trackLabel={row.templateTrackLabel ?? ''}
        timetableLabel={row.templateTimetableLabel ?? ''}
      />
    );
  }
  return row.templateLabel;
};

const LearningContentDetailTable: React.FC<LearningContentDetailTableProps> = ({
  rows,
  seqColumnLabel = '순서',
}) => (
  <table className="cp-annual-cross-topic-detail-table">
    <thead>
      <tr>
        <th className="cp-annual-cross-topic-detail-col-center cp-annual-cross-topic-detail-col-seq">{seqColumnLabel}</th>
        <th className="cp-annual-cross-topic-detail-col-center">날짜</th>
        <th className="cp-annual-cross-topic-detail-col-center cp-annual-cross-topic-detail-col-narrow">요일</th>
        <th className="cp-annual-cross-topic-detail-col-center cp-annual-cross-topic-detail-col-narrow">교시</th>
        <th className="cp-annual-cross-topic-detail-col-center cp-annual-cross-topic-detail-th-stacked">
          <span className="cp-annual-cross-topic-detail-th-line">편제</span>
          <span className="cp-annual-cross-topic-detail-th-line">(시간표명)</span>
        </th>
        <th>단원</th>
        <th>프로그램 내용</th>
        <th>쪽수</th>
        <th>보조쪽수</th>
        <th className="cp-annual-cross-topic-detail-col-center cp-annual-cross-topic-detail-col-period cp-annual-cross-topic-detail-th-stacked">
          <span className="cp-annual-cross-topic-detail-th-line">해당</span>
          <span className="cp-annual-cross-topic-detail-th-line">차시</span>
        </th>
        <th className="cp-annual-cross-topic-detail-col-center cp-annual-cross-topic-detail-col-period cp-annual-cross-topic-detail-th-stacked">
          <span className="cp-annual-cross-topic-detail-th-line">전체</span>
          <span className="cp-annual-cross-topic-detail-th-line">차시</span>
        </th>
        <th>준비물</th>
      </tr>
    </thead>
    <tbody>
      {rows.map((row, index) => {
        const learningCrossSuffixText = buildAnnualProgressLearningCrossSuffix(row.crossTopic, row.crossNote);
        return (
          <tr key={`${row.mondayIso}|${row.weekdayKey}|${row.slotIndex}|${row.seq}|${index}`}>
            <td className="cp-annual-cross-topic-detail-col-center cp-annual-cross-topic-detail-col-seq">{index + 1}</td>
            <td className="cp-annual-cross-topic-detail-col-center">{row.dateLabel}</td>
            <td className="cp-annual-cross-topic-detail-col-center cp-annual-cross-topic-detail-col-narrow">
              {row.weekdayLabel}
            </td>
            <td className="cp-annual-cross-topic-detail-col-center cp-annual-cross-topic-detail-col-narrow">
              {row.periodLabel}
            </td>
            <td className="cp-annual-cross-topic-detail-col-center">{renderTemplateLabel(row)}</td>
            <td>{row.unit}</td>
            <td className="cp-annual-cross-topic-detail-learning">
              {learningCrossSuffixText ? (
                <>
                  {row.learning}
                  <span className="cp-program-learning-cross-suffix">
                    {row.learning ? ' ' : ''}
                    {learningCrossSuffixText}
                  </span>
                </>
              ) : (
                row.learning
              )}
            </td>
            <td>{row.page}</td>
            <td>{row.assistantPage}</td>
            <td className="cp-annual-cross-topic-detail-col-center cp-annual-cross-topic-detail-col-period">
              <span className="cp-annual-cross-topic-detail-period-value">{row.currentPeriod}</span>
            </td>
            <td className="cp-annual-cross-topic-detail-col-center cp-annual-cross-topic-detail-col-period">
              <span className="cp-annual-cross-topic-detail-period-value">{row.totalPeriod}</span>
            </td>
            <td>{row.material}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
);

export default LearningContentDetailTable;
